import styled from 'styled-components';

import Icon, { ICON_USER } from '~/components/icon';

import { breakpointDesktop } from './game-info.styles';
import { Seat } from './types';

const SeatsWrapper = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	align-items: center;
	margin-bottom: 24px;

	${breakpointDesktop} {
		margin-bottom: 12px;
	}
`;

const SeatPill = styled.div<{ active: boolean }>`
	width: 36px;
	height: 36px;
	border-radius: 100%;
	background-color: rgba(255, 255, 255, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		opacity: ${({ active }) => (active ? '.15' : '1')};
	}
`;

const Seats = ({ seats }: { seats: Seat[] }) => {
	return (
		<SeatsWrapper>
			{seats.map(seat => (
				<SeatPill key={`seat-${seat.position}`} active={seat.active}>
					<Icon type={ICON_USER} width={16} height={16} />
				</SeatPill>
			))}
		</SeatsWrapper>
	);
};

export default Seats;
